import { apiError, billingClient } from '@/lib/api/ts-rest';
import { createLogger } from '@/lib/logger';
import { queryKeys } from '@/lib/query-keys';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

const log = createLogger('useCancelBillingRun');

export function useCancelBillingRun() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (runId: string) => {
      const res = await billingClient.cancelRun({ params: { id: runId } });
      if (res.status !== 200) throw apiError(res, "Impossible d'annuler ce run");
      return res.body;
    },
    onSuccess: () => {
      // The run and everything derived from it are gone — drop the domain.
      queryClient.invalidateQueries({ queryKey: queryKeys.billing.root() });
      toast.success('Run de facturation annulé, données et fichiers supprimés');
    },
    onError: (error) => {
      toast.error(
        error instanceof Error ? error.message : "Impossible d'annuler ce run",
      );
      log.error('Error cancelling billing run', { error });
    },
  });
}
